export const arrowChevronDownIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9818 2.32746L14.0342 0.417969L7.99938 6.3344L1.96721 0.420518L0.0195312 2.33001L6.0517 8.24388L6.05121 8.24436L7.99889 10.1538L7.99938 10.1534L7.99987 10.1539L9.94755 8.24436L9.94706 8.24388L15.9818 2.32746Z" fill="var(--zbp-svg-primary-color, black)"/>
</svg>
`;
